import { configureStore } from '@reduxjs/toolkit'
import todosReducer from '../redux/reducer'
// import filtersReducer from '../features/filters/filtersSlice'
import reducer from './reducer';
import thunk from 'redux-thunk';

const store = configureStore({
  reducer: {
     todos: todosReducer
    // filters: filtersReducer
  }
})
export default store